import { useEffect, useRef, useState } from 'react';

/**
 * One-shot reveal when the element intersects the viewport.
 * When `disabled` is true (e.g. prefers-reduced-motion), `revealed` stays true from the first render.
 */
export function useRevealOnScroll(disabled: boolean, rootMargin = '0px 0px -11% 0px') {
    const ref = useRef<HTMLElement | null>(null);
    const [revealed, setRevealed] = useState(disabled);

    useEffect(() => {
        if (disabled) return;
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => {
                const hit = entries.some((e) => e.isIntersecting);
                if (hit) {
                    setRevealed(true);
                    io.disconnect();
                }
            },
            { rootMargin, threshold: 0.06 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [disabled, rootMargin]);

    return { ref, revealed };
}
